export class FatalPromotionException {
    protected previous: unknown;
    protected original: unknown;
    protected message: string;

    /**
     * A fatal promotional exception
     * @param message
     * @param exception
     * @param previous
     */
    constructor(message: string, exception: unknown, previous: unknown) {
        console.error("A fatal error has occurred when calculating promotions", message, exception);

        this.previous = previous;
        this.original = exception;
        this.message = message;
    }

    public toString(): string {
        return this.message;
    }
}

export class PromotionException {
    protected original?: unknown;
    protected message: string;

    /**
     * A promotional exception
     * @param message
     * @param exception
     */
    constructor(message: string, exception?: unknown) {
        console.error(message, exception);

        this.original = exception;
        this.message = message;
    }

    public toString(): string {
        return `${this.message} ${this.original}`;
    }
}

export class CalculationException {
    protected message: string;

    constructor(message: string) {
        console.error(message);

        this.message = message;
    }

    public toString(): string {
        return this.message;
    }
}
